import { useLocalSearchParams } from "expo-router"
import { LoanAnalysisScreen } from "@/screens/loananalysis/LoanAnalysisScreen"

export default function LoanAnalysisPage() {
  const { id } = useLocalSearchParams<{ id: string }>()

  return <LoanAnalysisScreen loanId={id} />
}
